import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { BehaviorSubject, take } from 'rxjs';

import { fileToBase64 } from '@core/common-legacy';

export type CoverLetterData = { base64: string; name: string };
export type CoverLetterFileData = Record<number, CoverLetterData> | CoverLetterData | null;

@Injectable()
export class CoverLetterFileStoreService {
  public data$: Observable<CoverLetterFileData>;
  private data: BehaviorSubject<CoverLetterFileData> = new BehaviorSubject(null);

  constructor() {
    this.data$ = this.data.asObservable();
  }

  public set(file: File, candidateId?: number): void {
    fileToBase64(file)
      .pipe(take(1))
      .subscribe(base64 => {
        if (candidateId) {
          this.data.next({ ...this.data.getValue(), [candidateId]: { base64, name: file.name } });
        } else {
          this.data.next({ base64, name: file.name });
        }
      });
  }

  public get(candidateId?: number): CoverLetterData | null {
    if (candidateId) {
      return (<Record<number, CoverLetterData>>this.data.getValue())?.[candidateId] ?? null;
    }

    return <CoverLetterData | null>this.data.getValue();
  }

  public remove(candidateId?: number): void {
    if (candidateId) {
      const dataWithoutElement = { ...this.data.getValue() };
      delete (<Record<number, File>>dataWithoutElement)[candidateId];
      this.data.next(dataWithoutElement);
    } else {
      this.data.next(null);
    }
  }
}
